import { ISanityItemOption } from '@rbi-ctg/menu';

import { shouldDisplayItemOption } from './should-display-item-option';

import { and, minLengthWithDefaultValue, some } from '..';

export const shouldDisplayItemOptionGroup = and(
  minLengthWithDefaultValue<ISanityItemOption[]>(1, []),
  some(shouldDisplayItemOption)
);
